import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSoftware } from '@/lib/api';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { PageHero, Section, SectionTitle } from '@/components/shared/Section';
import { ShieldCheck, ArrowRight, MessageCircle, LayoutDashboard, BarChart3, Gauge, Briefcase, RefreshCw, Database, ShoppingCart } from 'lucide-react';

const iconMap = { 'control-panel': LayoutDashboard, 'analytics': BarChart3, 'ceo-cockpit': Gauge, 'c-suite': Briefcase, 'synkro': RefreshCw, 'bms': Database, 'venddi': ShoppingCart };

export default function SoftwareHub() {
  const [software, setSoftware] = useState([]);
  useEffect(() => { getSoftware().then(r => setSoftware(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero badge="PLATAFORMA SOFTWARE" badgeIcon={ShieldCheck} h1="Software propio ALLCOM" subtitle="Gestión de flota, analytics, cockpits ejecutivos y más. Diferenciador clave de ALLCOM."
        primaryCTA={<Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg">Ver demo <ArrowRight className="w-4 h-4" /></Link>}
        secondaryCTA={<a href="https://wa.me/56975294340" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-emerald-400 border border-emerald-400/30 rounded-xl hover:bg-emerald-400/10"><MessageCircle className="w-4 h-4" /> WhatsApp</a>}
      />
      <Section>
        <motion.div variants={stagger} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {software.map((sw) => {
            const Icon = iconMap[sw.slug] || LayoutDashboard;
            return (
              <motion.div key={sw.slug} variants={fadeUp}>
                <Link to={`/software/${sw.slug}`} className="group block p-6 sm:p-8 rounded-2xl bg-white border border-slate-200 shadow-[0_10px_30px_rgba(2,6,23,0.08)] card-hover h-full">
                  <div className="w-12 h-12 rounded-xl bg-sky-50 border border-sky-100 flex items-center justify-center mb-4 group-hover:bg-[#0A2540] group-hover:border-[#0A2540] transition-colors">
                    <Icon className="w-6 h-6 text-[#0EA5E9] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-lg font-semibold mb-2 group-hover:text-[#0EA5E9] transition-colors" style={{fontFamily:'Syne,sans-serif'}}>{sw.name}</h3>
                  <p className="text-sm text-[#64748B] leading-relaxed mb-4">{sw.description}</p>
                  <ul className="space-y-1.5">
                    {sw.features?.slice(0,3).map((f,i) => <li key={i} className="text-xs text-slate-500 flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]" />{f}</li>)}
                  </ul>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </Section>
    </div>
  );
}
